var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 20,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "white",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "white",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 11,
    height: 11,
    rx: 1,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuInactive);
export default __webpack_public_path__ + "static/media/menu-inactive.b30307da7aa97dfd7773b30e40a59f18.svg";
export { ForwardRef as ReactComponent };